// Platform brand constants — consumed at FE bootstrap before
// useQuery(['project', projectId]) resolves to the per-project brand. CI grep
// parity check across this file and backend/src/branding.ts (per
// CONVENTIONS §Branding).

export const PLATFORM_NAME = 'RubixEMS';
export const PLATFORM_COLOR_PRIMARY = '#43469c';
export const PLATFORM_COLOR_ON_PRIMARY = '#ffffff';

// The platform's own legal links, shown in the footer of every email beside the
// project's identity — OUR terms, not the project's: a technician never agreed
// to their employer's terms in order to receive a ticket (ADR-070).
// Product identity, so constants here rather than env (CONVENTIONS §Branding);
// they become deployment-overridable on the same trigger as the white-label
// logo. EMPTY = the footer omits the link entirely, never a dead one.
export const PLATFORM_TERMS_URL = '';
export const PLATFORM_PRIVACY_URL = '';
